// The exact sound telescope plays for an incoming patient message
// (src/common/constants.js in telescope). Dogfooding: the support inbox should
// sound like the inbox the team already lives in.
export const NEW_NOTIFICATION_SOUND =
  'https://media.brainhi.com/public/brain-manager%2Fyou-wouldnt-believe.mp3';

// Seeded into the composer when an agent lands on a conversation no human has
// answered yet. Generic on purpose — greet and ask, nothing to edit — so it can
// go out with a single Enter. Same tuteo as Lara's script (lara.json in the
// support service): the first human line must not switch register on the
// customer.
export const FIRST_REPLY_GREETING =
  '¡Saludos! Gracias por comunicarte con BrainHi. ¿En qué puedo ayudarte?';
